// cookie names are literal, not patterns
const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const match = (name: string): RegExpMatchArray | null =>
  document.cookie.match('(^|;) ?' + escapeRegExp(name) + '=([^;]*)(;|$)');

// the token cookie goes to parseJwt undecoded
export const readRawCookie = (name: string): string | null => {
  const found = match(name);
  return found ? found[2] : null;
};

export const readCookie = (name: string): string | null => {
  const value = readRawCookie(name);
  return value ? decodeURIComponent(value) : value;
};

// an empty cookie is present but falsy
export const hasCookie = (name: string): boolean => match(name) !== null;

// path matches the server's cookies and the clearAllCookies sweep
export const writeCookie = (name: string, value: string, expires: Date): void => {
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`;
};

export const clearAllCookies = (): void => {
  const hostname = window.location.hostname;
  const isThinkmdDomain = hostname === 'thinkmd.ai' || hostname.endsWith('.thinkmd.ai');

  document.cookie.split(';').forEach(c => {
    const expiredCookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/');

    document.cookie = expiredCookie;
    if (isThinkmdDomain) {
      document.cookie = `${expiredCookie};domain=.thinkmd.ai`;
    }
  });
};
